import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const OptionsIconContainer = styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 24,
    width: 24,
    marginRight: 10,
}));

export default OptionsIconContainer;
